export const getAccountInfo = (dispatch: any, address: string) =>
  dispatch({
    type: "GET_ACCOUNTINFO",
    address,
  });

export const getAccountInfoSuccess = (
  rise: number,
  cash: number,
  trx: number,
  created: number
) => ({
  type: "GET_ACCOUNTINFO_SUCCESS",
  rise,
  cash,
  trx,
  created,
});

export const getAccountInfoFailure = (error: Error) => ({
  type: "GET_ACCOUNTINFO_FAILURE",
  error,
});
